import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/homeData";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200/80 bg-background-50/85 backdrop-blur-md shadow-sm"
          : "bg-background-50/70 backdrop-blur-sm"
      }`}
    >
      <nav
        className="mx-auto flex h-[68px] max-w-[1200px] items-center justify-between px-4 md:px-6"
        aria-label="主导航"
      >
        {/* 品牌 */}
        <a
          href="#hero"
          className="flex items-center gap-2.5 cursor-pointer"
          onClick={() => setOpen(false)}
        >
          <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary-500 text-xl text-background-50 shadow-sm">
            🍉
          </span>
          <span className="flex items-baseline gap-1 font-heading">
            <span className="text-2xl leading-none text-primary-500">52</span>
            <span className="text-2xl leading-none text-foreground-950">吃瓜</span>
          </span>
        </a>

        {/* 桌面导航 */}
        <ul className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="inline-block whitespace-nowrap rounded-full px-3.5 py-2 text-sm font-medium text-foreground-700 hover:bg-accent-100 hover:text-accent-700 transition-colors cursor-pointer"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#battle"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-secondary-500 px-4 py-2 text-sm font-semibold text-foreground-950 hover:bg-secondary-600 transition-colors cursor-pointer"
          >
            <i className="ri-sword-line" />
            随机斗图
          </a>
          <a
            href="#about"
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            我要投稿
            <i className="ri-arrow-right-up-line" />
          </a>
        </div>

        {/* 移动端汉堡 */}
        <button
          type="button"
          aria-label="打开菜单"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full bg-background-100 text-foreground-900 md:hidden cursor-pointer"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} />
        </button>
      </nav>

      {/* 移动端面板 */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-6 pt-3 md:hidden">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-xl px-4 py-3 text-sm font-medium text-foreground-800 hover:bg-accent-100 hover:text-accent-700 cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="mt-3 grid grid-cols-2 gap-3">
            <a
              href="#battle"
              onClick={() => setOpen(false)}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-secondary-500 px-4 py-2.5 text-sm font-semibold text-foreground-950 cursor-pointer"
            >
              <i className="ri-sword-line" /> 随机斗图
            </a>
            <a
              href="#about"
              onClick={() => setOpen(false)}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 cursor-pointer"
            >
              我要投稿
            </a>
          </div>
        </div>
      )}
    </header>
  );
}